import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { deleteAccountRpc, uninstallAppRpc } from '../../../__generated__/chirp/com/hubspot/unifiedaccount/rpc/AccountRpc';
import { useListAccountsForAppQuery as useListAccountsForAppQueryGenerated } from '../../../__generated__/chirp/com/hubspot/unifiedaccount/rpc/AccountRpc.hooks';
import { useListSupportedAppsQuery as useListSupportedAppsQueryGenerated } from '../../../__generated__/chirp/com/hubspot/unifiedaccount/rpc/AppRpc.hooks';

// Import and re-export types for convenience

export function useListSupportedAppsQuery(options) {
  return useListSupportedAppsQueryGenerated({
    context: options !== null && options !== void 0 && options.timeout ? {
      timeout: options.timeout
    } : undefined
  });
}
export function useListAccountsForAppQuery(appId, options) {
  return useListAccountsForAppQueryGenerated({
    variables: {
      appId
    },
    context: options !== null && options !== void 0 && options.timeout ? {
      timeout: options.timeout
    } : undefined
  });
}

// Create RPC client for imperative calls
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Deletes a unified account
 */
export function deleteAccount(accountId) {
  return chirpClient.call(deleteAccountRpc, {
    request: {
      accountId
    }
  });
}

/**
 * Deletes/uninstalls an app and all its associated accounts
 */
export function uninstallApp(appId) {
  return chirpClient.call(uninstallAppRpc, {
    request: {
      appId
    }
  });
}

// Generic Result type for algebraic data type handling

// Success response type

// Error response type

// Combined response type

/**
 * Creates a new unified account
 */
export function createAccount(portalId, createAccountRequest) {
  return http.post('/api/unified-account/v1/account/create', {
    data: createAccountRequest,
    query: {
      portalId
    }
  });
}
/**
 * Creates a new unified account
 * For now the `appName` in the request is optional.
 * Response contains `appName` from the request (if it exists) or from the app listing:
 * https://github.com/HubSpotEngineering/UnifiedAccount/pull/335
 */

export function startAuthFlow(portalId, startAuthFlowRequest) {
  return http.post('/api/unified-account/v1/account/start', {
    data: startAuthFlowRequest,
    query: {
      portalId
    }
  });
}

/**
 * Gets the authorize URL for a new unified account
 */

export function getAuthorizeUrl(portalId, getAuthorizeUrlRequest) {
  return http.post('/api/unified-account/v1/account/authorize', {
    data: getAuthorizeUrlRequest,
    query: {
      portalId
    }
  });
}

/**
 * Gets the authorize URL for a existing unified account
 */

export function getAuthorizeForReconnectUrl(portalId, getAuthorizeForReconnectUrlRequest) {
  return http.post('/api/unified-account/v1/account/authorize-for-reconnect', {
    data: getAuthorizeForReconnectUrlRequest,
    query: {
      portalId
    }
  });
}
export function reconnectAccount(portalId, reconnectAccountRequest) {
  return http.post('/api/unified-account/v1/account/reconnect', {
    data: reconnectAccountRequest,
    query: {
      portalId
    }
  });
}
export function migrationReconnectAccount(portalId, migrationReconnectRequest) {
  return http.post('/api/unified-account/v1/migration/oauthor/account/create', {
    data: migrationReconnectRequest,
    query: {
      portalId
    }
  });
}